<template>
  <div>
    <el-form label-width="90" inline size="mini">
      <el-form-item label="客户名称">
        <el-input v-model="query.name" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="query.cuser" placeholder="请输入联系人员"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="query.phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="联系地址">
        <el-input v-model="query.address" placeholder="请输入联系地址"></el-input>
      </el-form-item>
      <el-form-item label="描述信息">
        <el-input v-model="query.memo" placeholder="请输入描述信息"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="ue_searchAgent" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="ue_AddAgent" icon="el-icon-plus">增加</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="agentData" :height="tb_height" stripe border size="mini">
      <el-table-column label="编号" prop="id" width="60"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="ue_EditAgent(scope.row)"
                     size="mini" type="text" title="编辑">编辑
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" prop="name" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="联系人" prop="cuser" width="120"></el-table-column>
      <el-table-column label="联系方式" prop="phone" width="120"></el-table-column>
      <el-table-column label="联系地址" prop="address" width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="描述" prop="memo" show-overflow-tooltip></el-table-column>
      <el-table-column label="创建日期" :formatter="f_format" prop="ctdate" width="120"></el-table-column>
      <el-table-column label="创建人员" :formatter="f_format" prop="ctuid" width="120"></el-table-column>
      <el-table-column label="所属公司" :formatter="f_format" prop="companyid" width="150"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar" style="position: absolute; bottom: 35px; z-index: 100; margin: 0;">
      <el-pagination layout="total,sizes,prev, pager, next,jumper, ->"
                     @current-change="ue_page_CurrentChange"
                     @size-change="ue_page_SizeChange"
                     :page-size="pageSize" :total="total" style="float:left;">
      </el-pagination>
    </el-col>

    <el-dialog title="客户信息维护"
               class="d-dialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="showEdit"
               width="550px">

      <el-form label-width="80px"
               size="mini"
               ref="Edit"
               :rules="rules"
               :model="Edit">
        <el-form-item label="编号">
          <el-input v-model="Edit.id" :disabled="true" placeholder="自动生成"></el-input>
        </el-form-item>

        <el-form-item label="客户名称" prop="name">
          <el-input v-model="Edit.name" placeholder="请输入客户名称"></el-input>
        </el-form-item>

        <el-form-item label="联系人">
          <el-input v-model="Edit.cuser" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="Edit.phone" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="联系地址">
          <el-input v-model="Edit.address" placeholder="请输入联系地址"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="Edit.memo" type="textarea" rows="5" maxlength="255" show-word-limit
                    placeholder="请输入描述信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="showEdit = false">关闭</el-button>
        <el-button size="mini" type="primary" @click.native="ue_saveAgent">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import * as Api from '../api/api'
  import Utils from '../api/Utils'

  export default {
    data() {
      return {
        query: {},
        user: JSON.parse(sessionStorage.getItem("user")),
        page: 1,
        pageSize: 10,
        total: 0,
        tb_height:"400px",
        agentData: [],
        userData: [],
        companyData: [],
        showEdit: false,
        Edit: {},
        rules: {
          name: [
            {required: true, message: '客户名称不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {
      this.f_GetCompany();
      this.f_GetAgent();
      window.onresize=()=>{
        this.f_AutoHeight();
      }
    },
    methods: {
      ue_searchAgent() {
        this.f_GetAgent();
      },
      ue_EditAgent(row) {
        this.showEdit = true;
        this.Edit = JSON.parse(JSON.stringify(row));
      },
      ue_AddAgent() {
        this.showEdit = true;
        this.Edit = {
          name: "",
          memo: "",
          ctdate: Utils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
          ctuid: this.user.id,
          companyid: this.user.companyid,
          cuser: "",
          phone: "",
          address: ""
        };
      },
      ue_saveAgent() {
        this.$refs.Edit.validate((valid) => {
          if (valid) {
            let parm = JSON.parse(JSON.stringify(this.Edit));
            Api.AddAgent(parm).then(res => {
              if (res.code === 1) {
                this.showEdit = false;
                this.f_GetAgent();
              } else {
                this.$alert(`保存失败:${res.error}`, "提示信息",{type:'error'});
              }
            });
          }
        });
      },
      f_GetAgent() {
        let parm = {
          page: this.page,
          pageSize: this.pageSize
        };
        for (let key in this.query) {
          if (this.query[key] && this.query[key] !== "") {
            parm[key] = this.query[key];
          }
        }
        Api.GetPageAgent(parm, this.user.companyid).then(res => {
          if (res.code === 1) {
            this.agentData = res.data;
            this.total = res.total;
          }
          this.f_AutoHeight();
        })
      },
      ue_page_CurrentChange(page) {
        this.page = page;
        this.f_GetAgent();
      },
      ue_page_SizeChange(size) {
        this.pageSize = size;
        this.f_GetAgent();
      },
      f_format(row, column, cellValue) {
        let col = column.property;
        let result = cellValue;
        if (col === "companyid") {
          let dd = this.companyData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col === "ctdate" && cellValue !== "") result = Utils.formatDate(new Date(cellValue), "yyyy-MM-dd hh:mm");
        if (col === "ctuid") {
          let dd = this.userData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        return result;
      },
      f_GetUser() {
        Api.GetUser({}, this.user.companyid).then(res => {
          if (res.code === 1)
            this.userData = res.data;
        });
      },
      f_GetCompany() {
        Api.GetCompany({}).then(res => {
          if (res.code === 1)
            this.companyData = res.data;
          this.f_GetUser();
        })
      },
      f_AutoHeight () {
        //初始化界面计算明细表格高度
        let gd = document.getElementsByClassName('el-table')[0];
        let bb = document.getElementsByClassName('toolbar')[0];
        let gh = Utils.GetElHeight(gd, bb);
        this.tb_height = '' + parseInt(gh)+'px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Agents.vue